export const SHOW_LIST_ITEM_GROUP_HEADER = false;
export const SHOW_DESKTOP_CUSTOMIZATION_BACK_ON_NAVBAR = true;
